import { type Page } from './const'
import { PagesId } from '../../src/ts/enums/PagesId'

const lang: string = 'en'

export const enPages: Page[] = [
  {
    pathname: `/${lang}/`,
    component: './src/containers/Home.tsx',
    pageId: PagesId.Home,
  },
  {
    pathname: `/${lang}/contact-us`,
    component: './src/containers/ContactUs.tsx',
    pageId: PagesId.ContactUs,
  },
  {
    pathname: `/${lang}/legal/`,
    component: './src/containers/Legal/Home.tsx',
    pageId: PagesId.LegalHome,
  },
  {
    pathname: '/en/legal/privacy-policy/',
    component: './src/containers/Legal/PrivacyPolicy.tsx',
    pageId: PagesId.LegalPrivacyPolicy,
  },
  {
    pathname: '/en/legal/terms-and-conditions/',
    component: './src/containers/Legal/TermsAndConditions.tsx',
    pageId: PagesId.LegalTermsAndConditions,
  },
  {
    pathname: `/${lang}/legal/refund-policy/`,
    component: './src/containers/Legal/RefundPolicy.tsx',
    pageId: PagesId.LegalRefundPolicy,
  },
  {
    pathname: `/${lang}/orders/`,
    component: './src/containers/Orders/Home.tsx',
    pageId: PagesId.OrdersHome,
  },
  {
    pathname: `/${lang}/orders/create-manual-sales`,
    component: './src/containers/Orders/CreateManualUserOrders.tsx',
    pageId: PagesId.CreateManualUserOrders,
  },
  {
    pathname: `/${lang}/orders/create-manual-purchases`,
    component: './src/containers/Orders/CreateManualStoreOrders.tsx',
    pageId: PagesId.CreateManualStoreOrders,
  },
  {
    pathname: `/${lang}/orders/canceling-orders`,
    component: './src/containers/Orders/HowToCancelOrders.tsx',
    pageId: PagesId.HowToCancelOrders,
  },
  {
    pathname: `/${lang}/orders/process-orders-returns`,
    component: './src/containers/Orders/OrdersReturns.tsx',
    pageId: PagesId.OrdersReturns,
  },
  {
    pathname: `/${lang}/orders/payment-methods`,
    component: './src/containers/Orders/PaymentMethods.tsx',
    pageId: PagesId.OrdersPaymentMethods,
  },
  {
    pathname: `/${lang}/orders/managing-payments-for-orders`,
    component: './src/containers/Orders/ManagingPaymentsForOrders.tsx',
    pageId: PagesId.ManagingPaymentsForOrders,
  },
  {
    pathname: `/${lang}/orders/managing-docs-for-orders`,
    component: './src/containers/Orders/ManagingDocsForOrders.tsx',
    pageId: PagesId.ManagingDocsForOrders,
  },
  {
    pathname: `/${lang}/items-and-inventory/`,
    component: './src/containers/Items/Home.tsx',
    pageId: PagesId.ItemsHome,
  },
  {
    pathname: `/${lang}/items-and-inventory/create-products`,
    component: './src/containers/Items/CreateItems.tsx',
    pageId: PagesId.CreateItems,
  },
  {
    pathname: `/${lang}/items-and-inventory/update-products`,
    component: './src/containers/Items/UpdateItems.tsx',
    pageId: PagesId.UpdateItems,
  },
  {
    pathname: `/${lang}/items-and-inventory/upload-and-manage-items-images`,
    component: './src/containers/Items/ManageItemsMedia.tsx',
    pageId: PagesId.ManageItemsMedia,
  },
  {
    pathname: `/${lang}/items-and-inventory/write-off-inventory`,
    component: './src/containers/Items/WriteOffInventory.tsx',
    pageId: PagesId.WriteOffInventory,
  },
  {
    pathname: `/${lang}/items-and-inventory/pricing-your-products`,
    component: './src/containers/Items/PricingYourProducts.tsx',
    pageId: PagesId.PricingYourProducts,
  }
]
